"use strict";
/*
 * Created on 25. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var FlagSet_1 = require("../../../core/model/FlagSet");

var ObjectUtils_1 = require("../../../core/utils/ObjectUtils");

var ReleasePartValidationKey_1 = require("../../../release/model/alerts/ReleasePartValidationKey");

var RequiresRecalculation_1 = require("../../../release/model/alerts/RequiresRecalculation");
/**
 * Family created event.
 * @author Radek Beran
 */


var FamilyCreated =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(FamilyCreated, _EntityEventFlag_1$En);

  function FamilyCreated(familyName) {
    var _this;

    _classCallCheck(this, FamilyCreated);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(FamilyCreated).call(this));
    _this.familyName = familyName;
    return _this;
  }

  _createClass(FamilyCreated, [{
    key: "createMessage",
    value: function createMessage() {
      return new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, ReleasePartValidationKey_1.ReleasePartMessageCode.FamilyCreated, immutable_1.List.of(this.familyName), null, null, FlagSet_1.FlagSet.of(ValidationResultFlag_1.ValidationResultFlag, RequiresRecalculation_1.RequiresRecalculation.INSTANCE));
    }
  }, {
    key: "validate",
    value: function validate() {
      return true;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (other instanceof FamilyCreated) {
        return _get(_getPrototypeOf(FamilyCreated.prototype), "equals", this).call(this, other) && this.familyName === other.familyName;
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.tag + this.familyName);
    }
  }]);

  return FamilyCreated;
}(EntityEventFlag_1.EntityEventFlag);

exports.FamilyCreated = FamilyCreated;
FamilyCreated.TAG = EntityEventFlag_1.EntityEventFlag.register(FamilyCreated);
FamilyCreated.PROTOTYPE = new FamilyCreated('');